import React from "react";
import "../style/Testimonials.css";
import { testimonialsDetails } from "../data/testimonialsData";
import { LuSparkles, LuStar } from "react-icons/lu";

const Testimonials = () => {
  return (
    <section className="testimonials">
      <div className="testimonials-inner">
        <div className="section-heading">
          <LuSparkles className="testimonials-sparkle" size="1.5em" />
          <h2 className="section-title testimonials-title">
            Loved by Our Customers
          </h2>
        </div>
        <div className="testimonials-grid">
          {testimonialsDetails.map((item) => (
            <figure key={item.id} className="testimonial-card">
              <div className="testimonial-stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <LuStar key={i} size="1em" className="testimonial-star" />
                ))}
              </div>
              <blockquote className="testimonial-quote">
                “{item.quote}”
              </blockquote>
              <figcaption className="testimonial-author">
                {item.name}{" "}
                <span className="testimonial-location">
                  · {item.location}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
